
import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import AdminHeader from './components/AdminHeader';
import { AdminNotificationProvider } from '../../contexts/AdminNotificationContext';
import AdminSidebar from './components/AdminSidebar';
import DashboardOverview from './components/DashboardOverview';
// import ProjectsManagement from './components/ProjectsManagement'; // Đã xóa module project
// import ProjectCategoriesManagement from './components/ProjectCategoriesManagement'; // Đã xóa module project
import NewsManagement from './components/NewsManagement';
import NewsCategoriesManagement from './components/NewsCategoriesManagement';
import ContactsManagement from './components/ContactsManagement';
import HeroSectionManagement from './components/HeroSectionManagement';
import SectionsManagement from './components/SectionsManagement';
import GalleryManagement from './components/GalleryManagement';
import LogoAndFaviconManagement from './components/LogoAndFaviconManagement';
import SettingsManagement from './components/SettingsManagement';
import AdminGuard from '../../components/admin/AdminGuard';
// import AcademyProjectsManagement from './components/AcademyProjectsManagement'; // Đã xóa module academy
import UnifiedServicesManagement from './components/UnifiedServicesManagement';
import SectionItemsManagement from './components/SectionItemsManagement';
import SEOManagement from './components/SEOManagement';
import AboutPageManagement from './components/AboutPageManagement';

const AdminPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  
  // Đọc tab từ URL, mặc định là 'dashboard' nếu không có
  const activeTab = searchParams.get('tab') || 'dashboard';
  
  // Hàm để thay đổi tab và update URL
  const setActiveTab = (tab: string) => {
    setSearchParams({ tab });
  };

  // Thêm data attribute để ẩn widget Talk with Us
  useEffect(() => {
    document.body.setAttribute('data-page', 'admin');
    
    // Function để ẩn widget
    const hideWidget = () => {
      const widgets = document.querySelectorAll('[id*="readdy"], [class*="readdy"], iframe[src*="readdy"], [id*="assistant"], [class*="assistant"]');
      widgets.forEach(widget => {
        if (widget instanceof HTMLElement) {
          widget.style.display = 'none';
          widget.style.visibility = 'hidden';
          widget.style.opacity = '0';
          widget.style.pointerEvents = 'none';
        }
      });
    };
    
    // Ẩn widget ngay lập tức
    hideWidget();
    
    // Ẩn widget sau mỗi 100ms để catch widget được load sau
    const interval = setInterval(hideWidget, 100);
    
    // Cleanup khi component unmount
    return () => {
      document.body.removeAttribute('data-page');
      clearInterval(interval);
    };
  }, []);

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <DashboardOverview />;
      case 'solutions':
      case 'services':
        return <UnifiedServicesManagement />;
      case 'section-items':
        return <SectionItemsManagement />;
      // case 'projects': // Đã xóa module project
      //   return <ProjectsManagement />;
      // case 'project-categories': // Đã xóa module project
      //   return <ProjectCategoriesManagement />;
      case 'news':
        return <NewsManagement />;
      case 'news-categories':
        return <NewsCategoriesManagement />;
      // case 'academy-projects': // Đã xóa module academy
      //   return <AcademyProjectsManagement />;
      case 'contacts':
        return <ContactsManagement />;
      case 'seo-management':
        return <SEOManagement />;
      case 'about-story':
      case 'about-mission':
      case 'about-values':
      case 'about-brand':
      case 'about-services':
        return <AboutPageManagement activeTabFromUrl={activeTab} />;
      case 'banners':
        return <HeroSectionManagement />;
      case 'sections':
        return <SectionsManagement />;
      case 'gallery':
        return <GalleryManagement />;
      case 'logo-favicon':
        return <LogoAndFaviconManagement />;
      case 'settings':
      case 'settings-general':
      case 'settings-seo':
      case 'settings-social':
      case 'settings-email':
      case 'settings-footer':
      case 'settings-backup':
      case 'settings-security':
        return <SettingsManagement activeTabFromUrl={activeTab} setActiveTabInUrl={setActiveTab} />;
      default:
        return <DashboardOverview />;
    }
  };

  return (
    <AdminGuard>
      <AdminNotificationProvider>
        <div className="min-h-screen bg-[#F5F7FA]">
          <AdminHeader 
            isSidebarOpen={!isSidebarCollapsed}
            setIsSidebarOpen={setIsSidebarCollapsed}
            setActiveTab={setActiveTab}
          />
        
        <div className="flex">
          <AdminSidebar 
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            isCollapsed={isSidebarCollapsed}
            setIsCollapsed={setIsSidebarCollapsed}
          />
          
          <main className={`flex-1 transition-all duration-300 ${isSidebarCollapsed ? 'ml-20' : 'ml-64'}`}>
            <div className="p-8">
              {renderContent()}
            </div>
          </main>
        </div>
      </div>
      </AdminNotificationProvider>
    </AdminGuard>
  );
};

export default AdminPage;
